module.exports = __webpack_public_path__ + "static/media/menu.666c3080.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 1100
// module chunks = 0